import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextPageHeaderProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextPageHeader = ({
  label,
  ellipsis,
  color = 'text-ds-natural-600',
}: TextPageHeaderProps) => (
  <Typography
    color={color}
    label={label}
    ellipsis={ellipsis}
    tagName="h1"
    fontSize="text-ds-800"
    lineHeight="leading-ds-700"
    fontWeight="font-ds-medium"
  />
);
